import omit from 'lodash/omit';
import { tryExecute } from '../utils/base';
import { getProjectState, setProjectState } from './project';

export const getTasks = () => {
  return getProjectState('tasks');
};

export const appendTaskQueue = (queueData) => {
  const tasks = getTasks();
  const queue = tasks.fe_queue || [];

  setProjectState(
    {
      tasks: {
        ...tasks,
        fe_queue: queue.concat(queueData),
      },
    },
    {
      __skipTracking: true,
    },
  );
};

export const shiftTaskQueue = () => {
  const tasks = getTasks();
  const queue = tasks.fe_queue || [];
  const firstItem = queue[0];

  setProjectState(
    {
      tasks: {
        ...tasks,
        fe_queue: queue.slice(1),
      },
    },
    {
      __skipTracking: true,
    },
  );

  return firstItem;
};

export const updateCurrentTask = (taskLocalId) => {
  setProjectState(
    {
      tasks: {
        ...getTasks(),
        current: taskLocalId,
      },
    },
    {
      __skipTracking: true,
    },
  );
};

export const updateQueue = (queueId, paratialData) => {
  const tasks = getTasks();
  const queue = tasks.fe_queue || [];

  setProjectState(
    {
      tasks: {
        ...tasks,
        fe_queue: queue.map((item) => {
          if (item.id === queueId) {
            return tryExecute(paratialData, item);
          }

          return item;
        }),
      },
    },
    {
      __skipTracking: true,
    },
  );
};

export const removeQueue = (queueId) => {
  const tasks = getTasks();
  const queue = tasks.fe_queue || [];

  setProjectState(
    {
      tasks: {
        ...tasks,
        fe_queue: queue.filter((item) => item.id !== queueId),
      },
    },
    {
      __skipTracking: true,
    },
  );
};

export const updateTask = (taskId, paratialData) => {
  const tasks = getTasks();
  const nextTaskData = tryExecute(paratialData, tasks.map[taskId]);

  setProjectState(
    {
      tasks: {
        ...tasks,
        map: Object.assign({}, tasks.map, {
          [taskId]: nextTaskData,
        }),
      },
    },
    {
      __skipTracking: true,
    },
  );
};

export const removeTask = (taskLocalId) => {
  const tasks = getTasks();

  setProjectState(
    {
      tasks: {
        ...tasks,
        map: omit(tasks.map, taskLocalId),
      },
    },
    {
      __skipTracking: true,
    },
  );
};
